function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 739",
  d: "M11.968 11.345l-4.574 4.574V1.127a.627.627 0 10-1.254 0v14.791l-4.574-4.574a.627.627 0 00-.887.887l5.644 5.644a.627.627 0 00.887 0l5.644-5.644a.627.627 0 10-.887-.887z"
});

function SvgArrow2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13.543 18.559"
  }, props), _ref);
}

export default SvgArrow2;